import { Component, Prop, Vue } from 'vue-property-decorator';
import {  itiHttpService, itiSignalRService, i18n, itiMessageService } from '@/iti-core-vue';
import DxList from 'devextreme-vue/list';
import chatModule from '@/store/modules/chat-module';
import moment from 'moment';

@Component({
    components: {    
        DxList    
    },
})
export default class LastMessage extends Vue {
    
    @Prop() public idArea!: number;    

    public get lastMessages() {                              
        return chatModule.messages;
    }

    public mounted() {
        if (!isNaN(this.idArea) && this.idArea != 0) {
            chatModule.getLastMessagesByAmbitId(this.idArea).catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});                                      
        }                                
    }          

    public getDate(date: Date) {          
        if (date.toString().charAt(0) == '0') { 
            return "";
        } else {         
            return moment(date).format('DD-MM-YYYY HH:mm');
        }
    }

    public goToChat(e: any) {   
        this.$router.push({ name: 'ChatUnaSala', params: { id: this.idArea.toString() } });
    }

}
